import {
  ClassesIllustration,
  OverviewIllustration,
  SubjectIllustration,
  TabBarItem,
  TeacherIllustration,
} from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { BaseOutlet } from '../../../../components/BaseOutlet/BaseOutlet';
import { IconMenu } from '../../../../components/IconMenu/IconMenu';
import { IconMenuItem } from '../../../../components/IconMenuItem/IconMenuItem';
import { Page } from '../../../../components/Page/Page';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';

export type LessonTabFilterType = 'assigned' | 'unassigned' | 'all' | 'subjectContainerLessons';

export type LessonTabsType = Omit<TabBarItem, 'id'> & { id: LessonTabFilterType };

export const LessonsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { classUuid, subjectUuid, teacherUuid } = useParams();
  const location = useLocation();
  const permissions = usePermissionChecker();

  const isDetail = classUuid || subjectUuid || teacherUuid;

  return (
    <Page isForbidden={!permissions?.canReadDeputate()} title={!isDetail ? t('lesson.title', { count: 2 }) : undefined}>
      {!isDetail && (
        <IconMenu variant='tabs' hasMarginBottom>
          <IconMenuItem
            label={`${t('deputate.menuItems.overview')}`}
            icon={<OverviewIllustration />}
            bubbleType={5}
            onClick={() => navigate('')}
            active={location.pathname.endsWith(t('routes.lessons.slug'))}
          />
          <IconMenuItem
            label={`${t('deputate.menuItems.classes')}`}
            icon={<ClassesIllustration />}
            bubbleType={3}
            onClick={() => navigate(t('routes.lessons.plan.classes.slug'))}
            active={location.pathname.endsWith(t('routes.lessons.plan.classes.slug'))}
          />
          <IconMenuItem
            label={`${t('deputate.menuItems.subject')}`}
            icon={<SubjectIllustration />}
            bubbleType={1}
            onClick={() => navigate(t('routes.lessons.plan.subjects.slug'))}
            active={location.pathname.endsWith(t('routes.lessons.plan.subjects.slug'))}
          />
          <IconMenuItem
            label={`${t('deputate.menuItems.teacher')}`}
            icon={<TeacherIllustration />}
            bubbleType={3}
            onClick={() => navigate(t('routes.lessons.plan.teachers.slug'))}
            active={location.pathname.endsWith(t('routes.lessons.plan.teachers.slug'))}
          />
        </IconMenu>
      )}
      <BaseOutlet />
    </Page>
  );
};
